/**
 * NGX display Auth Instagram object.
 *
 * Summary of responsibilities:
 *
 *  - handles all functionality related to authenticating users against Instagram
 */
export default (function() {
  // Properties.
  var _config = {
      id:    'Instagram',
      ngxId: 'instagram',

      authURI:     'https://instagram.com/oauth/authorize',
      redirectURI: '/display/auth/callback/instagram',
      apiURI:      'https://api.instagram.com/v1',

      authPollMs: 250,
      authMode:   'popup',
    },
    _state = {
      authenticated:    false,
      authResponse:     null,
      identifyResponse: null,
      ready:            false,
    },
    _callbacks = {},
    _event = null,
    _appConfig = null,
    _authWindow = null;

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // Init.
  var init = function(config) {
      // Merge injected params with our own.
      _.extend(_config, config);

      // Convenience shortcuts.
      _event = NGX.App.Events;
      _appConfig = NGX.App.config;

      // Update ready state.
      _state.ready = true;
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Log user in.
    login = function(callbackSuccess, callbackFail, redirectUrl, authRedirectData) {
      // Store reference to callbacks.
      _callbacks.login = {};
      _callbacks.login.success = callbackSuccess;
      _callbacks.login.fail = callbackFail;

      // If we are processing a redirect response.
      if (authRedirectData) {
        handleStatusChange(authRedirectData.responseObject);
      } else {
        // Build the auth URL.
        var authURL =
          _config.authURI +
          '/?client_id=' +
          _config.apiKey +
          '&redirect_uri=' +
          encodeURIComponent(
            _appConfig.displayURL + _config.redirectURI + '?redirectUrl=' + encodeURIComponent(redirectUrl)
          ) +
          '&response_type=token';

        // Open auth window or redirect based on config.
        switch (_config.authMode) {
          case 'popup':
            _authWindow = window.open(authURL, '', 'width=640, height=480');
            break;

          case 'redirect':
            window.location.href = authURL;
            break;
        }

        // Poll for login response.
        pollLoginResponse();
      }
    },
    pollLoginResponse = function() {
      try {
        // Check if the response object exists.
        if (typeof _authWindow.responseObject !== 'undefined') {
          // If it does, retrieve it and pass off to handler.
          handleStatusChange(_authWindow.responseObject);

          // Attempt to close auth window.
          _authWindow.close();
        } else {
          // Otherwise contiue to poll.
          setTimeout(pollLoginResponse, _config.authPollMs);
        }
      } catch (exception) {
        // Otherwise contiue to poll.
        setTimeout(pollLoginResponse, _config.authPollMs);
      }
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // When a user logged in/out, handle the change.
    handleStatusChange = function(response) {
      // Store response.
      response.href = decodeURIComponent(response.href);
      _state.authResponse = response;

      // If error.
      if (response.hasOwnProperty('error') && response.error !== '') {
        _state.authenticated = false;

        // Execute callback.
        _callbacks.login.fail();
      } else {
        // If success.
        _state.authenticated = true;

        // Get access token hash.
        var accessToken = parseQueryString(response.href, 'access_token');

        // Build sanitised response object to pass to success callback.
        var authResponse = {};
        authResponse.network = _config.id;
        authResponse.data = {
          token: accessToken,
        };

        // Execute callback.
        _callbacks.login.success(authResponse);
      }
    },
    parseQueryString = function(queryString, needle) {
      needle = needle.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?#&]' + needle + '=([^&#]*)'),
        results = regex.exec(queryString);

      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    // Identify a user (retrieve as many details about them as we can) after being logged in.
    identify = function(user, callbackSuccess, callbackFail) {
      // Store reference to callbacks.
      _callbacks.identify = {};
      _callbacks.identify.success = callbackSuccess;
      _callbacks.identify.fail = callbackFail;

      // Attempt to identify user.
      var token = user.authedNetworks.Instagram.response.token;

      // Make API call.
      $.getJSON(_config.apiURI + '/users/self/?access_token=' + token + '&callback=?', {}, function(response) {
        // Store response.
        _state.identifyResponse = response;

        // If success.
        if (response.data && !response.error) {
          // Build sanitised response object to pass to success callback.
          var identifyResponse = {};
          identifyResponse.network = _config.id;

          // Attempt to extract user id.
          var id = '';
          try {
            id = response.data.id;
            id = id.toString();
          } catch (exception) {}

          // Attempt to extract name.
          var firstName = '';
          var lastName = '';
          try {
            if (response.data.hasOwnProperty('full_name')) {
              var nameHasParts = response.data.full_name.indexOf(' ') >= 0 ? true : false;
              if (nameHasParts) {
                var nameParts = response.data.full_name.split(' ');
                lastName = nameParts.pop();
                firstName = nameParts.join(' ');
              } else {
                firstName = response.data.full_name;
              }
            }
          } catch (exception) {}

          // Attempt to extract email.
          var email = '';
          try {
          } catch (exception) {}

          // Attempt to extract associated data.
          var associatedData = {};
          associatedData.ngxId = _config.ngxId;
          try {
            // Profile URL.
            if (response.data.hasOwnProperty('username')) {
              associatedData.profileUrl = 'https://instagram.com/' + response.data.username;
            }

            // Profile Username.
            if (response.data.hasOwnProperty('username')) {
              associatedData.profileUsername = response.data.username;
            }

            // Avatar URL.
            if (response.data.hasOwnProperty('profile_picture')) {
              if (response.data.profile_picture.toLowerCase().indexOf('anonymous') === -1) {
                associatedData.avatarUrl = response.data.profile_picture;
              }
            }
          } catch (exception) {}

          identifyResponse.data = {
            id:             id,
            firstName:      firstName,
            lastName:       lastName,
            email:          email,
            associatedData: associatedData,
          };

          // Execute callback.
          _callbacks.identify.success(identifyResponse);
        } else {
          // If fail.
          // Execute callback.
          _callbacks.identify.fail();
        }
      });
    };

  // Expose public API.
  return {
    init:              init,
    login:             login,
    identify:          identify,
    accountRestricted: false,
  };
})();
